export default "__VITE_ASSET__e0283991__"